















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FeedbackNegativeView extends Vue {
  private get title(): string {
    return this.$store.getters['negativeReviewTitle'];
  }

  private get description(): string {
    return this.$store.getters['negativeReviewDescription'];
  }
}
